import type { IsoDateTime } from "@figurepos/fgr-lib-business-logic/lib/common/dateTime/types"
import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { Observable, defer } from "rxjs"
import { createHttpRequest } from "../../../api/utils/httpRequest"
import { Config, Environment } from "../../../utils/config"

export const CommandParamsTypeEnum = {
    LogSqlQuery: "log-sql-query",
    LogReduxState: "log-redux-state",
    RunReduxAction: "run-redux-action",
    CodePushUpdate: "code-push-update",
    Restart: "restart",
    Crash: "crash",
    DownloadConfig: "download-config",
    DownloadData: "download-data",
    StopDataDownload: "stop-data-download",
    UploadMetrics: "UploadMetrics",
    UploadLogs: "UploadLogs",
    ReportTerminalInfo: "ReportTerminalInfo",
}

export const CommandParamsTypeNames = {
    "log-sql-query": "Log SQL Query",
    "log-redux-state": "Log Redux State",
    "run-redux-action": "Run Redux Action",
    "code-push-update": "CodePush Update",
    restart: "Restart",
    crash: "Crash",
    "download-config": "Download Config",
    "download-data": "Download Data",
    "stop-data-download": "Stop Data Download",
    UploadMetrics: "Upload Terminal Metrics",
    UploadLogs: "Upload Terminal Logs",
    ReportTerminalInfo: "Report Terminal Info",
}

export type CommandParamsType = (typeof CommandParamsTypeEnum)[keyof typeof CommandParamsTypeEnum]

export const getConsolePollingData = (headers: Record<string, any>, last: IsoDateTime): Observable<any> =>
    defer(() =>
        createHttpRequest({
            method: "GET",
            path: `/console-updates?last=${last}`,
            headers: headers,
        })
    )

export const getRemoteScreenshotName = (requestedAt: IsoDateTime) => `support-screenshot-${requestedAt}.jpg`

export const getRemoteScreenshotUrl = (
    terminalId: string,
    locationId: Maybe<string>,
    selectedAccountId: Maybe<string>,
    requestedAt: IsoDateTime
) => {
    const dateForFilePath = new Date(requestedAt)
    const year = dateForFilePath.getUTCFullYear()
    const month = dateForFilePath.getUTCMonth() + 1 // thank you js for fuckin indexing months from 0

    const day = dateForFilePath.getUTCDate()
    const accId = selectedAccountId || "unknownAccount"
    const locId = locationId ?? "unknownLocation"
    const filename = getRemoteScreenshotName(requestedAt)

    const env = Config.environment === Environment.Production ? "prod" : "dev"

    return (
        `https://fgr-account-assets-${env}.s3.amazonaws.com/account-assets/` +
        `${accId}/misc/${locId}/${terminalId}/${year}/${month}/${day}/${filename}`
    )
}
